import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import { userManagementList } from '../constants/account-settings';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/account-settings.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import UsersEn from '../public/services/accountSettings/users_en.webp';
import ReportsEn from '../public/services/accountSettings/reports_en.webp';
import BillingEn from '../public/services/accountSettings/billing_en.webp';
import UsersRu from '../public/services/accountSettings/users_ru.webp';
import ReportsRu from '../public/services/accountSettings/reports_ru.webp';
import BillingRu from '../public/services/accountSettings/billing_ru.webp';

const images = {
  en: {
    users: UsersEn,
    reports: ReportsEn,
    billing: BillingEn,
  },
  ru: {
    users: UsersRu,
    reports: ReportsRu,
    billing: BillingRu,
  }
};

export default function AccountSettings() {
  const router = useRouter();
  const { t } = useTranslation('accountSettings');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection title='Account Settings' description='accountSettingsDescription' documentationLink='https://help.icdc.io/account/' lang={router.locale} />

      <section className={styles.forAdmin}>
        <div>
          <h2>{t('forAdmin.title')}</h2>
          <p>{t('forAdmin.description')}</p>
        </div>
        <div>
          <Image src='/accountSettings.webp' alt='For administrator' width={500} height={331} unoptimized loading='lazy' />
        </div>
      </section>

      <section className={styles.userManagement}>
        <div>
          <h2>{t('userManagement.title')}</h2>
        </div>
        {userManagementList.map((element, index) => (
          <div key={index} className={styles.userManagement__item}>
            <h3>{t(element.title)}</h3>
            <p>{t(element.description)}</p>
            <Link href={t(element.docsUrl)}>
              <a className={'btn outlined btn-link'}>
                {t('readDocs')}
              </a>
            </Link>
            <div className={styles.img_container}>
              <Image src={images[router.locale][element.imgUrl]} alt={t("serviceScreenshotAlt")} />
            </div>
          </div>
        ))}
      </section>

      <section className={styles.start}>
        <h4>{t('start.title')}</h4>
        <Link href={'location-admin'}>
          <a>
            <button className={'btn cloud'}>{t('discoverLA')}</button>
          </a>
        </Link>
      </section>
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['accountSettings', 'common']),
  },
});
